




























import Vue from 'vue';
import { EProductVariantType } from '@ringana/configs';
import { IProductVariant } from '@/common/interfaces/products.interface';
import ProductVariantColor from '@/components/newsingleproductpage/subcomponents/productvariant/ProductVariantColor.vue';
import ProductVariantSize from '@/components/newsingleproductpage/subcomponents/productvariant/ProductVariantSize.vue';
import ProductPageSelect from '@/components/newsingleproductpage/subcomponents/select/ProductPageSelect.vue';
import { IOldCustomSelectOption } from '@/common/interfaces/shared.interface';

interface IProductVariantSelection {
  EProductVariantType: typeof EProductVariantType;
}

export default Vue.extend({
  name: `ProductVariantSelection`,
  components: { ProductPageSelect, ProductVariantColor, ProductVariantSize },
  data(): IProductVariantSelection {
    return {
      EProductVariantType,
    };
  },
  computed: {
    languageVariantOptions(): IOldCustomSelectOption[] {
      const selectedVariant: IProductVariant[] = this.productVariants.filter(variant => variant.type === EProductVariantType.LANGUAGE && variant.slug === this.currentSlug);
      const sortedVariants: IProductVariant[] = [...selectedVariant, ...this.productVariants.filter(variant => variant.type === EProductVariantType.LANGUAGE && variant.slug !== this.currentSlug)];
      return sortedVariants
        .filter(variant => variant.type === EProductVariantType.LANGUAGE)
        .map(variant => ({
          code: variant.id,
          label: this.$t(`products-ufe:variants.languages.${variant.language?.toLowerCase()}`),
        }));
    },
  },
  props: {
    currentSlug: {
      required: true,
      type: String,
    },
    productVariants: {
      required: true,
      type: Array as () => IProductVariant[],
    },
  },
});
